/** Fold an api response back into the pane's brand selection.
 *  `sent` is the brand the request carried (its snapshot), `current` is what
 *  the pane shows now. If they differ the user picked again mid-flight: keep
 *  their newer pick, the queued re-apply will honour it. */
export function reconcileBrand(current, sent, applied) {
    if (current !== sent)
        return { selected: current };
    if (!sent)
        return { selected: null, auto: applied };
    // Server may apply a different brand than picked (pick not permitted):
    // show what was actually applied.
    return { selected: applied };
}
